module.exports = __webpack_public_path__ + "img/appltCourse-img29.2ec75706.png";